import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthCallBackComponent } from './core/auth/auth-callback.component'
import { LandingPageComponent } from './landing-page/landing-page.component'
import { HomePageComponent } from './home/home-page.component'
import { loadingGuard } from './guards/loading-guard.guard'

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [loadingGuard],
  },
  {
    path: 'home',
    component: HomePageComponent,
  },
  {
    path: 'clients',
    loadChildren: () => import('./broker/broker.module').then((m) => m.BrokerModule),
  },
  {
    path: 'credit',
    loadChildren: () => import('./credit/credit.module').then((m) => m.CreditModule),
  },
  {
    path: 'structured-credit',
    loadChildren: () =>
      import('./structured-credit/structured-credit.module').then((m) => m.StructuredCreditModule),
  },
  {
    path: 'npi',
    loadChildren: () => import('./npi/npi.module').then((m) => m.NpiModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'modeling',
    loadChildren: () =>
      import('./model-runner/model-runner.module').then((m) => m.MODEL_RUNNER_ROUTES),
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'auth-callback',
    component: AuthCallBackComponent,
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { enableTracing: false, scrollPositionRestoration: 'top' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
